import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { NAV_SECTIONS } from '@/shared/components/layout/nav-config'

export interface BreadcrumbSegment {
  label: string
  path?: string
}

export function useBreadcrumbs(): BreadcrumbSegment[] {
  const { pathname } = useLocation()
  const { t } = useTranslation()

  return useMemo(() => {
    for (const section of NAV_SECTIONS) {
      // Direct link section (e.g. Home → /dashboard)
      if (section.path && section.path === pathname) {
        return [{ label: t(section.labelKey) }]
      }

      if (!section.groups) continue

      for (const group of section.groups) {
        for (const item of group.items) {
          if (item.path === pathname || pathname.startsWith(item.path + '/')) {
            // Find first navigable item in section for the section link
            const firstItem = section.groups[0]?.items[0]
            return [
              { label: t(section.labelKey), path: firstItem?.path },
              { label: t(group.labelKey) },
              { label: t(item.labelKey) },
            ]
          }
        }
      }
    }

    // No match in nav-config — return empty (toolbar will use page title as fallback)
    return []
  }, [pathname, t])
}
